import { useEffect } from "react";

const BASE = "https://sopaj.it";

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    const rel = selector.match(/rel=['"](\w+)['"]/);
    if (rel) el.setAttribute("rel", rel[1]);
    const prop = selector.match(/property=['"]([^'"]+)['"]/);
    if (prop) el.setAttribute("property", prop[1]);
    const name = selector.match(/name=['"]([^'"]+)['"]/);
    if (name) el.setAttribute("name", name[1]);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const SEO = ({ title, description, path = "/" }) => {
  useEffect(() => {
    const url = `${BASE}${path}`;
    document.title = title;
    setMeta("meta[name='description']", { content: description });
    setMeta("link[rel='canonical']", { href: url });
    setMeta("meta[property='og:title']", { content: title });
    setMeta("meta[property='og:description']", { content: description });
    setMeta("meta[property='og:url']", { content: url });
    setMeta("meta[name='twitter:title']", { content: title });
    setMeta("meta[name='twitter:description']", { content: description });
  }, [title, description, path]);
  return null;
};

export default SEO;
